module.exports = __webpack_public_path__ + "media/studyBuddy.d2910820.mp4";